import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'

export default function Layout() {
    const [sidebarOpen, setSidebarOpen] = useState(false)

    return (
        <div className="flex h-screen w-screen bg-neutral-50 overflow-hidden">
            <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            {/* Main Content */}
            <div className="flex flex-col flex-1 min-w-0">
                {/* Sticky Header */}
                <div className="sticky top-0 z-30 border-b border-gray-200 bg-white">
                    <Header onMenuClick={() => setSidebarOpen(true)} />
                </div>

                {/* Scrollable Main Content */}
                <main className="flex-1 overflow-y-auto overflow-x-hidden p-3 sm:p-4 lg:p-6">
                    <Outlet />
                </main>
            </div>
        </div>
    )
}
